import type { FileAPIPDFResponse } from "./types";
import useFetchTax from "./use-fetch-tax";

export default function useFile(id?: string) {
  const {
    isLoading: useFetchTaxIsLoading,
    error: useFetchTaxError,
    get,
  } = useFetchTax();

  const getFilePDFURL = async (id: string) => {
    const res = (await get(`me/file/${id}/pdf`)) as FileAPIPDFResponse;

    return res.data.url;
  };

  return {
    isLoading: useFetchTaxIsLoading,
    error: useFetchTaxError,
    getFilePDFURL: getFilePDFURL,
  };
}
